export const alertConstants = {
  SET_ALERT: 'alert/set',
  REMOVE_ALERT: 'alert/remove',
  CLEAR_ALERTS: 'alert/clear',

  SUCCESS: 'success',
  ERROR: 'danger',
  INFO: 'info',
}
